'use strict';
/* ==========================================================================
   core-local/hooks.js — "Round and Round": this lesson's hooks into the shared engine v2
   (shared/engine/v2/core/game.js reads window.LessonHooks). The maths cast, reused (DESIGN.md §3).

   speakers: the name tag + colour of each voice in the portrait dock's captions (core/dock.js), from the notebook
             pack's palette (docs/NOTEBOOK.md §2): Ms. Rivera = red pen, Jay = ballpoint ink.
   captions: fallback caption text + speaker for every line of content/labs.json (every beat's say, hint, after and on —
             after may be a list or {outcome: list}; on = {event: list}), so the labs caption before any voice is recorded.
             assets/vo/lines.json / who.json (what was recorded) win once lesson.json preload.voice names them.
   lab:      the shared lab kit's cast slots, teacher and the pad's 3.14 key (shared/engine/v2/LAB.md §0).
   The STAMPED card: the engine's default (lesson.json steps[].card + completeCard.nextFrom "finished").
   Puppets: rivera (rivera, rivera_point), jay (jay, jay_point): the line art of lessons/tails-due (copied into
            assets/img/). Facing (Puppet.NATIVE) as in tails-due / balance: jay and jay_point face the front (0, never
            mirrored); both rivera poses are +1 (rivera_point points to the viewer's RIGHT). In the labs Jay stands at
            the lower LEFT corner, Rivera at the lower RIGHT facing −1 (mirrored: she points left, at the work).
   ========================================================================== */
window.LessonHooks = {
  speakers: { rivera: { name: 'Ms. Rivera', color: '#d23f33' }, jay: { name: 'Jay', color: '#1d2b4f' } },
  captions({ labs } = {}) {
    const text = {}, who = {};
    const add = l => { if (l && l.id) { text[l.id] = l.text; who[l.id] = l.who; } };
    const each = v => (Array.isArray(v) ? v.forEach(add) : v && typeof v === 'object' ? Object.values(v).forEach(ls => (ls || []).forEach(add)) : null);
    const L = labs && labs.labs;
    if (L) for (const k of Object.keys(L)) for (const b of (L[k] && L[k].beats) || []) { each(b.say); each(b.hint); each(b.after); each(b.on); }
    return { text, who };
  },
  /* the shared lab kit's configuration (shared:core/lab.js, shared/engine/v2/LAB.md §0): Jay in the lower-left slot,
     Ms. Rivera in the lower-right one; she speaks a line with no "who" and writes in the given steps; the pad's extra
     key types 3.14 (keyboard p) */
  lab: {
    cast: { left: { who: 'jay' }, right: { who: 'rivera' } },
    teacher: 'rivera',
    pad: { extraKey: { label: '3.14', text: '3.14', kbd: 'p' } },
  },
};

/* the cast's poses (core/puppet.js: pose alias → image name; the first/default pose per character) */
(function () {
  const P = typeof window !== 'undefined' && window.Puppet;
  if (!P) return;                                   // node (tools/contentcheck.js reads only the speakers)
  P.POSES.rivera = { rivera: 'rivera', point: 'rivera_point', rivera_point: 'rivera_point' };
  P.POSES.jay = { jay: 'jay', point: 'jay_point', jay_point: 'jay_point' };
  P.DEFAULT.rivera = 'rivera'; P.DEFAULT.jay = 'jay';
  Object.assign(P.NATIVE, { rivera: 1, rivera_point: 1, jay: 0, jay_point: 0 });
})();
